<template>
  <v-dialog v-model="dialog" :persistent="persistent" transition="fade-transition" :width="width">
    <v-card>
      <v-card-title v-if="title" class="headline">{{title}}</v-card-title>
      <v-card-text>
        {{text}}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn data-test-id="confirmButton" @click="confirm()" :class="confirmButtonClasses">
          <v-icon left>mdi-check</v-icon>{{$t('common.confirm')}}
        </v-btn>
        <v-btn data-test-id="cancelButton" text @click="close()">
          <v-icon left>mdi-close</v-icon>{{$t('common.cancel')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  mixins: [],
  components: {},
  props: {
    title: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    persistent: {
      type: Boolean,
      default: false
    },
    entity: {
      required: false,
    },
    confirmAction: {
      type: Function,
      required: true
    },
    confirmButtonClasses: {
      type: String,
      default: 'primary'
    },
    closeAction: {
      type: Function,
      required: true
    },
    width: {
      default: 500
    }
  },
  data: function() {
    return {
      dialog: false
    };
  },
  watch: {
    visible: function(val) {
      this.dialog = val;
    },
    dialog: function(val) {
      if (val === false) {
        this.closeAction();
      }
    }
  },
  mounted() {
    this.dialog = this.visible;
  },
  methods: {
    confirm() {
      this.close();
      this.confirmAction(this.entity);
    },
    close() {
      this.$emit("input", null);
      this.dialog = false;
    }
  }
};
</script>
<style scoped>
</style>